<div class="login">
	&nbsp;
	<div class="loginColumns animated fadeInRight gray-medium-bg b-r-lg">
		<div class="text-center">
			<h2 class="font-bold">Alteração de Senha</h2>
		</div>

		<div>
      <form class="m-t" role="form" >
        <div class="form-group m-b">
          <input type="password" id="current" name="current" class="form-control" placeholder="Senha atual" [(ngModel)]="loginForm.current" required />
        </div>

        <div class="form-group m-b">
          <input type="password" id="new" name="new" class="form-control" placeholder="Nova senha" [(ngModel)]="loginForm.new" required />
        </div>      

        <div class="form-group m-b">
          <input type="password" id="new_confirm" name="new_confirm" class="form-control" [(ngModel)]="loginForm.new_confirm" placeholder="Confirmação da nova senha" required />
        </div>        

        <div *ngIf="invalido" class="form-group m-b m-t invalido-p-l">
          <p class="text-danger">{{ invalido }}</p>
        </div>

        <button type="submit" class="btn btn-primary block full-width m-b" (click)="aterarSenha()">Alterar Senha</button>
      </form>
		</div>
	</div>
</div>

<app-loading [loader]="isLoading"></app-loading>